/* headers de menu del costado */
import React, { Fragment } from 'react';
import { administracion, analista, basic, urgenciaV, mediaciones, fiscalizacion, seguimientoif
, analistaFichaTecnica } from 'routes/routesGroups';
import {
  PostAdd,
  AssignmentOutlined,
  LocalHospitalOutlined,
  AccountCircleOutlined,
  AccountBalance,
  AssignmentTurnedInOutlined,
/*   AssignmentLateOutlined,
  AssignmentTurnedIn, */
} from '@material-ui/icons';
import {
  APP_COLOR_FIZCALIZACION_PRIMARY,
  /*   APP_COLOR_FIZCALIZACION_SECONDARY, */
  APP_COLOR_MEDIACIONES_PRIMARY,
  APP_COLOR_MEDIACIONES_SECONDARY,
  APP_COLOR_SEGUIMIENTO_PRIMARY,
  /*   APP_COLOR_SEGUIMIENTO_SECONDARY, */
  APP_COLOR_URGENCIA_VITAL_PRIMARY,
  /*   APP_COLOR_URGENCIA_VITAL_SECONDARY, */
} from 'config/config';
// import { LocalHospital, AccountBox } from '@material-ui/core';

const content = () => {
  const location = window.location.pathname;
  var title = '';
  var icon = null;
  var bgColor = '';

  if (analista.includes(location)) {
    title = 'Seguimiento de Reclamos';
    icon = <AssignmentOutlined style={{ color: APP_COLOR_SEGUIMIENTO_PRIMARY, fontSize: 50 }} />;
  }

  if (seguimientoif.includes(location)) {
    title = 'Seguimiento de Reclamos IF';
    icon = <AssignmentOutlined style={{ color: 'green', fontSize: 50 }} />;
    /*  bgColor = APP_COLOR_SEGUIMIENTO_SECONDARY; */
  }

  if (analistaFichaTecnica.includes(location)) {
    title = 'Ficha Técnica';
    icon = <AssignmentOutlined style={{ color: APP_COLOR_SEGUIMIENTO_PRIMARY, fontSize: 50 }} />;
  }

  if (administracion.includes(location)) {
    title = 'Gestión de Usuarios';
    icon = <AccountCircleOutlined />;
  }

  if (urgenciaV.includes(location)) {
    title = 'Urgencia Vital';
    icon = <LocalHospitalOutlined style={{ color: APP_COLOR_URGENCIA_VITAL_PRIMARY, fontSize: 50 }} />;
    /*    bgColor = APP_COLOR_URGENCIA_VITAL_SECONDARY; */
  }

  if (mediaciones.includes(location)) {
    title = 'Mediaciones';
    icon = <AccountBalance style={{ color: APP_COLOR_MEDIACIONES_PRIMARY, fontSize: 50 }} />;
    bgColor = APP_COLOR_MEDIACIONES_SECONDARY;
  }

  if (fiscalizacion.includes(location)) {
    title = 'Fiscalización';
    icon = <AssignmentTurnedInOutlined style={{ color: APP_COLOR_FIZCALIZACION_PRIMARY, fontSize: 50 }} />;
    /*  bgColor = APP_COLOR_FIZCALIZACION_SECONDARY; */
  }

  if (basic.includes(location)) {
    title = 'Extranet';
    icon = <PostAdd />;
  }

  return { title: title, icon: icon, bgColor: bgColor };
};

export const Title = () => {
  const location = window.location.pathname;
  if (analistaFichaTecnica.includes(location)) {
    return <Fragment>{content().title}</Fragment>;
  }else{
    return <Fragment>{content().title}</Fragment>;
  }


};

export const Icon = () => {
  return <Fragment>{content().icon}</Fragment>;
};

export const bgColor = () => {
  return content().bgColor;
};
